module.exports = __webpack_public_path__ + "img/backgroundV2.dd333da0.png";